module.exports = __webpack_public_path__ + "img/VNL-alt.2067a348.svg";